import { OverlayRef } from '@angular/cdk/overlay';
import { Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

interface MenuButtonsList {
  id: string;
  menu: OverlayRef;
}

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  menu: OverlayRef;
  id: string;

  menuList: MenuButtonsList[] = [];

  constructor() {
    const router = inject(Router);

    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        this.menu = null;
      }
    });
  }

  setMenu(menu: OverlayRef, id: string) {
    this.menu = menu;
    this.id = this.menu.overlayElement.id;

    const idx = this.menuList.findIndex((m) => m.id === id);
    if (idx > -1) {
      this.menuList[idx].menu = menu;
    } else {
      this.menuList.push({ id: id, menu: menu });
    }
  }

  removeMenu(id) {
    this.menu = null;
    const idx: number = this.menuList.findIndex((o: any) => o.id === id);
    if (idx > -1) {
      this.menuList.splice(idx, 1);
    }
  }
}
